const React = require("react");
const { ChatbotProvider } = require("./src/context/ChatbotContext");
const { SessionProvider } = require("./src/context/SessionContext");
const { VWOProvider } = require("./src/context/VWOContext"); // your wrapper
const Chatbot = require("./src/components/Chatbot").default;
// PageSlugUpdater removed - slug now extracted directly from URL in ChatbotContext

// Configure FontAwesome to prevent flash of oversized icons
const { config } = require('@fortawesome/fontawesome-svg-core');
config.autoAddCss = false; // Tell Font Awesome to skip adding the CSS automatically

require("./src/styles/chatbot.css");
require('@fortawesome/fontawesome-svg-core/styles.css'); // Import the CSS manually

// Mount long-lived providers without VWO (VWO is page-specific)
exports.wrapRootElement = ({ element }) => {
  return (
    <SessionProvider>
      <ChatbotProvider>
        {element}
        <Chatbot />
      </ChatbotProvider>
    </SessionProvider>
  );
};

// Add VWO per-page with access to pageContext
exports.wrapPageElement = ({ element, props }) => {
  return (
    <VWOProvider pageContext={props.pageContext}>
      {element}
    </VWOProvider>
  );
};
